<template>
    <div class="section">
        <h2 class="section__title grey--text" data-aos="fade-up">{{ model.menu_title }}</h2>
        <div class="row_process">
            <div class="column-1">
                <ul class="column__ul">
                    <li v-for="item in model.process" data-aos="fade-up">{{ item.text }}</li>
                </ul>
                <v-spacer/>
            </div>
            <div class="column-2" v-if="images">
                <img class="column-2__image1" data-aos="fade-up" :src="getImage(images[0])" alt="process2">
                <img class="column-2__image2" data-aos="fade-up" :src="getImage(images[1])" alt="process3">
            </div>
            <div class="column-3" v-if="images">
                <img class="column-3__image" data-aos="fade-up" :src="getImage(images[2])" alt="process1">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['model'],
        data() {
            return {
                images: null
            }
        },
        methods: {
            getImage(image) {
                return this.$apiHost + image[0]
            }
        },
        created() {
            this.images = Object.values(this.model.images).map(i => Object.values(i) )
        }
    }
</script>

<style lang="scss" scoped>

    img {
        width: 100%;
        box-sizing: border-box;
    }

    /* стили сетки и ее компонентов */

    .row_process {
        width: 90%;
        margin-left: 10%;
        top: 160px;
        display: flex;
        flex-wrap: nowrap;
        box-sizing: border-box;
        bottom: 0;
        position: absolute;
        @media screen and (max-width: 1024px) {
            position: relative;
            height: auto;
            flex-wrap: wrap;
            max-height: 100%;
            top: 0;
        }
    }

    .column-1 {
        width: 30%;
        position: relative;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        font-family: "CirceBold", sans-serif;
        @media screen and (max-width: 1024px) {
            width: 40%;
            padding-top: 73px;
        }
        @media screen and (max-width: 800px) {
            width: 90%;
            padding-top: 0;
        }
    }

    .column__ul {
        padding: 30px 30px 0 30px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }

    .column__ul li {
        font-size: 3.1vh;
        line-height: 1.2;
        text-transform: uppercase;
        list-style-type: none;
        color: #000;
        width: 100%;
        box-sizing: border-box;
        @media screen and (max-width: 1400px) {
            font-size: 24px;
        }
        @media screen and (max-width: 1024px) {
            font-size: 22px;
            margin-bottom: 30px;
        }
        @media screen and (max-width: 800px) {
            padding-left: 0;
        }
    }

    .column-2 {
        flex-grow: 1;
        padding-right: 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        min-width: 340px;
        box-sizing: border-box;
        @media screen and (max-height: 1024px) {
            min-width: 250px;
        }
        @media screen and (max-width: 800px) {
        }
    }

    .column-2 img {
    }

    .column-2__image1 {
        padding-bottom: 20px;
    }

    .column-3 {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        @media screen and (max-width: 1024px) {
            width: 100%;
            margin-top: 20px;
            padding-right: 20px;
        }
        @media screen and (max-width: 800px) {
            padding-right: 20px;
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/home-page-components/ProcessBlock.vue